const fetchAuthenticatedContent = require("./fetchAuthenticatedContent");

module.exports = function saveUser(dispatch, user) {
	let method = "POST";
	let endpoint = `user/user`;
	if (user.id) {
		endpoint += `/${user.id}`;
		method = "PATCH";
	}

	return fetchAuthenticatedContent(dispatch, endpoint, method, {
		data: { ...user },
	});
};
